<template>
  <v-container class="ofertas-container">
    <v-row class="mt-10">
      <v-col cols="12" offset="0" lg="4" >
        <Oferta
          icon="menu_book"
          title="Ebook: Guia de inteligência de mercado e prospecção ativa"
          text="O Guia de inteligência de mercado tem o objetivo de te ajudar a começar a sua estratégia de prospecção B2B. Baixe agora e confira: porque a inteligência de mercado é tão importante, a diferença entre inbound e outbound, como especializar a sua equipe de vendas e mais."
          link="http://prospecte.econodata.com.br/guia-inteligencia-de-mercado-prospeccao-ativa-1"
        />
      </v-col>

      <v-col cols="12" lg="4" >
        <Oferta
          title="Ebook: Como usar o Agendor na gestão de equipes"
          icon="menu_book"
          link="http://materiais.agendor.com.br/como-usar-o-agendor-na-gestao-da-equipe-de-vendas"
          text="Baixe o material e aprenda como um CRM de vendas pode ajudar a gerenciar melhor seu time, tornar sua equipe mais independente e centralizar todas as informações de negociações em um só lugar. Acompanhe e avalie melhor o desempenho de sua equipe com mais eficácia!"
        />
      </v-col>

      <v-col cols="12" lg="4" >
        <Oferta
          title="Guia definitivo para qualificação de leads"
          icon="category"
          link="https://materiais.agendor.com.br/guia-definitivo-para-qualificacao-leads"
          text="Torne o processo de qualificação de leads da sua empresa mais assertivo. Baixe o material e entenda porque qualificar leads, quais são os  tipos e metodologias de qualificação, como a equipe de pré-vendas contribui para este processo e que ferramentas são essenciais para otimizar a qualificação de contatos."
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Oferta from './Oferta'
export default {
  components: { Oferta }
}
</script>

<style scoped>
.ofertas-container {
  padding: 5rem;
}
</style>